module.exports = __webpack_public_path__ + "img/diffuse.4df100fe.jpg";